// ---------------------------------------------------------------------------
// Hero / Intro Section
// ---------------------------------------------------------------------------

import profileImage from '../assets/profile/me.JPG';
import researchInterestsImage from '../assets/profile/ResearchInterests.png';

const hero = {
  greeting: "Hello, I'm",
  name: 'Jack',
  title: "I'm an ECE PhD Student.",

  lab: {
    name: 'The Embodied System Lab',
    url: 'https://embodiedsystem.com/',
  },
  university: {
    name: 'Northwestern',
    url: 'https://www.mccormick.northwestern.edu/electrical-computer/',
  },

  // Left and right profile images
  images: [
    { src: researchInterestsImage, alt: 'Research Interests' },
    { src: profileImage, alt: 'Jack Thoene' },
  ],

  cta: {
    primary: {
      text: 'View my work',
      href: '#publications',
    },
    secondary: {
      text: 'Download CV',
      file: require('../assets/contacts/CV_24March.pdf'),
    },
  },
};

export default hero;
